module.exports = "/images/Animal  Adventure.svg?620d27045699c0e445dce7b79f882570";